import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, StatusChip, fmtMoney } from '@smena/ui';
import { QueryState } from '@/components/QueryState';
import { PAYMENT_KIND_LABELS, fetchPayments } from './api';

// Оплаты одного аккаунта. Вносить новые - из общего реестра /payments: там сразу видно,
// как правка ложится на сводку выручки, и не приходится держать две формы.

export function AccountPaymentsTab({ accountId }: { accountId: string }) {
  const q = useQuery({
    queryKey: ['payments', accountId],
    queryFn: () => fetchPayments(accountId),
  });

  return (
    <QueryState
      isLoading={q.isLoading}
      error={q.error}
      isEmpty={q.data?.length === 0}
      emptyText="Оплат по этому аккаунту нет"
    >
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="border-b border-line text-left text-xs uppercase tracking-wider text-muted">
            <tr>
              <th className="px-4 py-2 font-medium">Дата</th>
              <th className="px-4 py-2 font-medium">Тип</th>
              <th className="px-4 py-2 text-right font-medium">Сумма</th>
              <th className="px-4 py-2 font-medium">Период</th>
              <th className="px-4 py-2 font-medium">Внёс</th>
              <th className="px-4 py-2 font-medium">Заметка</th>
            </tr>
          </thead>
          <tbody>
            {q.data?.map((p) => (
              <tr key={p.id} className="border-b border-line/60 last:border-0">
                <td className="whitespace-nowrap px-4 py-2 text-xs text-muted">
                  {new Date(p.paidAt).toLocaleDateString('ru-RU')}
                </td>
                <td className="px-4 py-2">
                  <StatusChip tone={p.kind === 'subscription' ? 'accent' : 'muted'}>
                    {PAYMENT_KIND_LABELS[p.kind] ?? p.kind}
                  </StatusChip>
                </td>
                <td className="px-4 py-2 text-right tabular-nums">{fmtMoney(p.amountRub)}</td>
                <td className="whitespace-nowrap px-4 py-2 text-xs text-muted">
                  {p.periodFrom || p.periodTo ? `${p.periodFrom ?? '…'} → ${p.periodTo ?? '…'}` : '-'}
                </td>
                <td className="px-4 py-2 font-mono text-[11px] text-muted">
                  {p.createdByEmail ?? '-'}
                </td>
                <td className="max-w-64 truncate px-4 py-2 text-xs text-muted">{p.note ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="border-t border-line px-4 py-2 text-xs text-muted">
          Внести оплату - в общем реестре{' '}
          <Link to="/payments" className="text-accent-fg hover:underline">
            Платежи
          </Link>
          .
        </div>
      </Card>
    </QueryState>
  );
}
